import React from "react";
import { PartyPopper, X } from "lucide-react";

const texto = (gerencia) => gerencia
  ? "Firmaste todos tus documentos. Ahora Gerencia firmará tu contrato y te avisaremos cuando quede listo."
  : "Firmaste todos tus documentos y tu contratación quedó completa. ¡Bienvenido(a) a la familia Human!";

export const RogeFelicitacionCard = ({ gerencia }) => (
  <div className="flex items-center gap-4 rounded-xl border border-emerald-200 bg-gradient-to-r from-emerald-50 to-white p-4 shadow-sm" data-testid="roge-felicitacion-card">
    <img src="/roge-cat.png" alt="Gato institucional Roge" className="h-24 w-auto shrink-0 drop-shadow-md sm:h-28" />
    <div className="min-w-0">
      <p className="flex items-center gap-2 font-display text-lg font-bold text-emerald-800"><PartyPopper className="h-5 w-5" /> ¡Lo lograste!</p>
      <p className="mt-1 text-sm text-slate-600">{texto(gerencia)}</p>
    </div>
  </div>
);

export const RogeFelicitacionModal = ({ gerencia, onClose }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" data-testid="roge-felicitacion-modal">
    <div className="relative w-full max-w-sm animate-in zoom-in-95 fade-in rounded-2xl bg-white p-6 text-center shadow-2xl duration-300">
      <button onClick={onClose} className="absolute right-3 top-3 rounded-lg p-1.5 text-slate-400 hover:bg-slate-100" aria-label="Cerrar" data-testid="roge-felicitacion-cerrar"><X className="h-4 w-4" /></button>
      <img src="/roge-cat.png" alt="Gato institucional Roge" className="mx-auto h-44 w-auto animate-bounce drop-shadow-lg [animation-iteration-count:2]" />
      <p className="mt-3 font-display text-2xl font-bold text-vino-800">¡Felicitaciones!</p>
      <p className="mt-2 text-sm text-slate-600">{texto(gerencia)}</p>
      <p className="mt-3 text-xs text-slate-400">— Roge, de Human RMSA</p>
      <button onClick={onClose} className="mt-5 w-full rounded-lg bg-vino-700 px-4 py-2.5 text-sm font-semibold text-white hover:bg-vino-800" data-testid="roge-felicitacion-ok">¡Gracias, Roge!</button>
    </div>
  </div>
);
